import { basicColors, type UiColor } from "simplydo/react/theme";
/** Shared palette for role icons, idea statuses, and other UI colour pickers. */
export const UI_COLOR_CHOOSER_OPTIONS = Object.keys(
  basicColors,
) as readonly UiColor[];

export type UiColorChooserOption = (typeof UI_COLOR_CHOOSER_OPTIONS)[number];

export function uiColorName(color: UiColor): string {
  return color.charAt(0).toUpperCase() + color.slice(1);
}
